export default __webpack_public_path__ + "35c71d62f5a321b28f3937450d5acceb.png";